import React from 'react'
import styled from 'styled-components'
import {useDispatch} from "react-redux";
import {setStockLabelLayer} from "../../libs/action";

export default function StockLabelLayer() {

    const dispatch = useDispatch()

    const onClickCloseLayerPopup = () => {
        dispatch(setStockLabelLayer(false))
    }

    return (
        <BackDrop className={'stockLabelLayer'}>
            <WrapperLayer>
                <WrapperCloseIcon>
                    <CloseIcon className="icon-close btn-layer-pop_clse" onClick={onClickCloseLayerPopup}></CloseIcon>
                </WrapperCloseIcon>
                <WrapperTitleText>행복쇼핑 <b>재고인증</b> 이란?</WrapperTitleText>
                <WrapperContents>
                    <WrapperContentsItem>
                        <WrapperContentsText>
                            <ContentsTitle>행복쇼핑의 [재고인증] 라벨은 어떤 상품에 부여될까요?</ContentsTitle>
                            <ContentsDescription>
                                - 행복쇼핑의 A.I 엔진이 <b>SCM 공급업체 정보</b>와 <b>시장 분석을 통해 90% 이상의 확률</b>로 <b>정상 <br/> &nbsp;&nbsp;구매가 가능한 상품</b>에
                                부여하고 있습니다.
                            </ContentsDescription>
                        </WrapperContentsText>
                        <WrapperIcon>
                            <StockLabelIcon className='stock-stocklayer1'/>
                        </WrapperIcon>
                    </WrapperContentsItem>
                    <Divider/>
                    <WrapperContentsItem>
                        <WrapperContentsText>
                            <ContentsTitle>[재고인증] 상품을 구매하면 이런 점이 좋아요!</ContentsTitle>
                            <ContentsDescription>
                                - 재고인증 상품으로만 견적을 구성하게 되면 <b>최저가로 구매가</b> 가능합니다.<br/>
                                - PC견적 플랫폼에 입점한 <b>모든 미니샵</b>이 <b>재고인증 상품을 판매</b>하고 있으므로 <b>상품 구매가<br/>
                                &nbsp;&nbsp;한층 쉬워</b>집니다.
                            </ContentsDescription>
                        </WrapperContentsText>
                        <WrapperIcon>
                            <StockLabelIcon className='stock-stocklayer2'/>
                        </WrapperIcon>
                    </WrapperContentsItem>
                </WrapperContents>

                <WrapperInfo>
                    <InfoText>
                        ㆍ행복쇼핑은 전문 <b>가격비교 사이트</b>입니다.
                    </InfoText>
                    <InfoText>
                        ㆍPC 견적 플랫폼에서 취급하는 상품은 그 <b>종류가 다양하고 방대</b>하며 <b>재고 상황의 변화 또한 심하여 [재고인증]</b> 라벨이 부여된 <b>상품 중</b>에서도<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>구매가 일부 불가능한 상품</b>이 있을 수 있음을 미리 알려드립니다.
                    </InfoText>
                </WrapperInfo>
            </WrapperLayer>
        </BackDrop>
    )
}

const BackDrop = styled.div`
    && {
        height: 100%;
        left: 0;
        min-width: 950px;
        position: fixed;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 220;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    !important;
        font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
    }
`

const WrapperLayer = styled.div`
    && {
        width: 758px;
        min-height: 503px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        padding: 14px 14px 22px 22px;
        box-sizing: border-box;
        border: 2px solid #333333;
    }
`


const WrapperCloseIcon = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`

const CloseIcon = styled.button`
    font-size: 31px;
    color: #418DED;
    :hover {
        color : #005796;
    }
`

const WrapperContents = styled.div`
    width: 695px;
    height: 283px;
    margin: 0px 6px 0px 7px;
    background-color: #F6F6F6;
    padding: 35px 0px 25px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const WrapperTitleText = styled.div`
    width: 100%;
    font-weight: bold;
    font-size: 32px;
    letter-spacing: -0.8px;
    line-height: 43px;
    margin-bottom: 25px;

    b {
        color: #F34522;
    }
`
const WrapperContentsItem = styled.div`
    width: 100%;
    min-height: 80px;
    padding: 0px 31px 0px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const WrapperContentsText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start
`

const ContentsTitle = styled.span`
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    line-height: 27px;
    margin-bottom: 15px;
`
const ContentsDescription = styled.span`
    font-size: 14px;
    text-align: left;
    line-height: 19px;
    color: #666666;

    b {
        color: #418DED;
    }
`

const WrapperIcon = styled.div`
    width: 80px;
    height: 80px;
    background-color: #ECECEC;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const StockLabelIcon = styled.i`
    font-size: 50px
`

const Divider = styled.div`
    width: 632px;
    border-top: 1px solid #DCDCDC;
    margin: 24px 0px 21px 0px;
`

const WrapperInfo = styled.div`
    width: 681px;
    height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 19px 6px 0px 7px;
`

const InfoText = styled.span`
    font-size: 12px;
    text-align: left;
    line-height: 20px;
    color: #666666;
    letter-spacing: -0.3px;

    b {
        font-weight: bold;
    }
`




// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/stockLabelLayer.js